import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-signout-callback',
  template: `<p>Signing you out...</p>`
})
export class SignoutCallbackComponent implements OnInit {
  constructor(private router: Router) {}

  async ngOnInit() {
    const tenantName = localStorage.getItem('__tenant');

    console.info('[Auth] OpenID Connect logout completed', {
      tenantName,
      timestamp: new Date().toISOString(),
    });

    await this.router.navigate(['/account/login'], {
      queryParams: tenantName ? { __tenant: tenantName } : undefined,
    });
  }
}
